/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-05-23 12:17:58
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-13 14:48:44
 * @FilePath: /designcenter/src/api/modules/common.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IRes } from '@/types'
import { getApiRequest } from '@/utils'

const request = getApiRequest()


export function queryPdfData(data: any) {
  return request.post<IRes<string | null>>('/design/export/queryPdfData', data)
}
export function queryProductList(data: any) {
  return request.post<IRes<string | null>>('/design/export/queryProductList', data)
}

export function savePdfData(data: any) {
  return request.post<IRes<string | null>>('/design/export/savePdfData', data)
}

export async function recordTechExportLog(params: any) {
  return request.get<IRes<unknown>>('/design/customer/recordTechExportLog', { params })
}


export function pdfNew(data: any) {
  return request.post('/design/export/technology/pdfNew', data, {
    responseType: 'blob',
    timeout: 600000, // 10分钟超时，支持大文件（50MB+）下载
    maxContentLength: Infinity, // 不限制响应体大小
    maxBodyLength: Infinity // 不限制请求体大小
  })
}